var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ticket',{attrs:{"tickets":_vm.tickets,"start-print":_vm.startPrint,"solde":_vm.solde,"html":_vm.html,"left-to-pay":_vm.leftToPay,"carrier":_vm.carrier,"for-merchant":_vm.forMerchant,"signature":_vm.signature,"reference":_vm.reference,"id-badge":_vm.idBadge,"floating-mode-enabled":_vm.floatingModeEnabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }